import React from "react";
import { Redirect } from "react-router-dom";
import { spUrl } from "utils/helpers";

const SPRedirect = ({ to }) => <Redirect to={spUrl(to)}/>;

export default SPRedirect;
